import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import {
    Grid,
    Typography,
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    TablePagination,
    TableFooter,
    Card,
    CardContent,
    Collapse,
    IconButton,
} from '@material-ui/core';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

import TablePaginationActions from 'Console/components/accountNotifications/TablePaginationActions';

import { selectAccountNotificationsData } from 'Console/data/applications/selectors';
import { updateNotification, fetchNotificationList } from 'Console/data/applications/actions';


const styles = (theme) => ({
    root: {
        flexGrow: 1,
        alignItems: 'center',
        padding: 24,
    },
    table: {
        width: '100%',
    },
    tableRow: {
        cursor: 'pointer',
    },
    tableWrapper: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.typography.pxToRem(20),
    },
    notificationUnreaded: {
        fontWeight: 'bold',
    },
    tableMessage: {
        width: '50%',
        overflow: 'hidden',
        height: theme.typography.pxToRem(17),
        lineHeight: 1.7,
    },
    expandedMessage: {
        paddingTop: theme.typography.pxToRem(16),
        paddingBottom: theme.typography.pxToRem(16),
    },
})

class AccountNotifications extends React.Component {
    state = {
        page: 0,
        rowsPerPage: 5,
        expandedRows: [],
    };

    componentDidMount() {
        const { match, fetchNotificationList } = this.props;
        fetchNotificationList(match.params.accountId);
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ page: 0, rowsPerPage: event.target.value });
    };

    expandRow = (notification) => {
        const { expandedRows } = this.state;
        const { updateNotification, match } = this.props;
        this.setState({ expandedRows: [...expandedRows, notification.businessKey] });

        if (notification.hasBeenSeen === false) {
            updateNotification(match.params.accountId, notification.businessKey, {
                hasBeenSeen: true,
            });
        }
    };

    collapseRow = (notificationId) => {
        const { expandedRows } = this.state;
        this.setState({ expandedRows: expandedRows.filter((id) => id !== notificationId) });
    };

    toggleNotificationRow = (notification) => () => {
        const { expandedRows } = this.state;
        if (expandedRows.includes(notification.businessKey)) {
            this.collapseRow(notification.businessKey);
        } else {
            this.expandRow(notification);
        }
    };

    render() {
        const { classes, intl, notifications } = this.props;
        const { rowsPerPage, page, expandedRows } = this.state;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, notifications.length - page * rowsPerPage);

        return (
            <Grid container className={classes.root}>
                <Grid item xs={12}>
                    <Grid container spacing={24} justify="center">
                        <Grid item xs={12} md={10} style={{ marginBottom: '28px' }}>
                            <Typography variant="h6">
                                {intl.formatMessage({ id: 'AccountNotifications.title' })}
                            </Typography>
                        </Grid>

                        <Grid item xs={12} md={10} className={classes.tableWrapper}>
                            <Card className={classes.card}>
                                <CardContent>
                                    <Table className={classes.table}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="right">
                                                    {intl.formatMessage({
                                                        id: 'AccountNotification.subject',
                                                    })}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {intl.formatMessage({
                                                        id: 'AccountNotification.message',
                                                    })}
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {notifications
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((notification) => (
                                                    <TableRow
                                                        className={classes.tableRow}
                                                        key={notification.businessKey}
                                                        onClick={this.toggleNotificationRow(
                                                            notification
                                                        )}
                                                    >
                                                        <TableCell
                                                            align="right"
                                                            className={classnames({
                                                                [classes.notificationUnreaded]:
                                                                    notification.hasBeenSeen === false,
                                                            })}
                                                            style={{ width: '16%' }}
                                                        >
                                                            {notification.subject}
                                                        </TableCell>
                                                        <TableCell
                                                            align="right"
                                                            className={classnames({
                                                                [classes.notificationUnreaded]:
                                                                    notification.hasBeenSeen === false,
                                                            })}
                                                        >
                                                            {!expandedRows.includes(
                                                                notification.businessKey
                                                            ) && (
                                                                <div className={classes.tableMessage}>
                                                                    {notification.message}
                                                                </div>
                                                            )}

                                                            <Collapse
                                                                hidden={
                                                                    !expandedRows.includes(
                                                                        notification.businessKey
                                                                    )
                                                                }
                                                                in={expandedRows.includes(
                                                                    notification.businessKey
                                                                )}
                                                            >
                                                                <div className={classes.expandedMessage}>
                                                                    {notification.message}
                                                                </div>
                                                            </Collapse>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 48 * emptyRows }}>
                                                    <TableCell colSpan={6} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                    colSpan={3}
                                                    count={notifications.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        native: true,
                                                    }}
                                                    onChangePage={this.handleChangePage}
                                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default connect(
    (state) => ({
        notifications: selectAccountNotificationsData(state),
    }),
    { updateNotification, fetchNotificationList }
)(withStyles(styles)(injectIntl(AccountNotifications)));
